import { getConfigBaseUrl } from '../../../services/apiService';

export const getHolidayDataQuery = () => `${getConfigBaseUrl()}/v1/holidaycalendar/all`;
export const uploadHolidayDataQuery = () => `${getConfigBaseUrl()}/v1/holidaycalendar`;
export const deleteHolidayQuery = (id: string) => `${getConfigBaseUrl()}/v1/holidaycalendar/${id}`;
